const talentLight = {
  areaBackground: 'var(--color-white)',
  areaBackgroundSecondary: 'var(--color-zinc-50)',
  borderRadius: 10,
  borderDash: [5, 5],
  pointRadius: 6,
  pointBorderWidth: 5,
  tooltipFontSize: 16,
  tooltipFontColor: 'var(--color-black)',
  horizontalLineColor: 'var(--color-zinc-50)',
  fontFamily: 'Manrope',
  fontColor: 'var(--color-black)',
  fontSize: 14,
  fontWeight: 400,
  fontTitleSize: 16,
  fontTitlePadding: 16,
  xLabelColor: 'var(--color-black)',
  xOffsetWidth: 10,
  gridLineColor: 'var(--color-zinc-200)',
  gridLineWidth: 1.2,
  doughnutBorderColor: 'var(--color-white)',
  chartTotalColor: '#585968',
  tickColor: '#748695',
  chartColors: [
    '#cbd0ff',
    '#ed5c5c',
    '#ffa800',
    '#a48adb',
    '#8cffc1',
    '#9e56b0',
    '#8cacff',
    '#ffdf8c',
    '#3aa98c',
    '#c6e780'
  ],
  chartDoughnutColors: [
    '#ed5c5c',
    '#ffa800',
    '#8cacff',
    '#8cffc1',
    '#9e56b0',
    '#ffdf8c',
    '#3aa98c',
    '#cbd0ff',
    '#c6e780'
  ],
  chartCircleColors: ['#ffa800', '#8cffc1'],
  bar: {
    tickFontSize: 18,
    colors: [
      '#656af6',
      '#F15A4D',
      '#13AA42',
      '#9E56B0',
      '#17BBAF',
      '#8348ED',
      '#ECCB2B',
      '#38AFF2',
      '#FF9F69'
    ]
  }
}

const talentDark = {
  areaBackground: '#343648',
  areaBackgroundSecondary: '#2b2c3a',
  borderRadius: 10,
  borderDash: [5, 5],
  pointRadius: 6,
  pointBorderWidth: 5,
  tooltipFontSize: 16,
  tooltipFontColor: 'var(--color-white)',
  horizontalLineColor: 'var(--color-zinc-50)',
  fontFamily: 'Manrope',
  fontColor: 'var(--color-white)',
  fontSize: 14,
  fontWeight: 400,
  fontTitleSize: 16,
  fontTitlePadding: 16,
  xLabelColor: '#8cacff',
  xOffsetWidth: 10,
  gridLineColor: 'var(--color-zinc-200)',
  gridLineWidth: 1.2,
  doughnutBorderColor: '#343648',
  chartTotalColor: 'var(--color-white)',
  tickColor: '#748695',
  chartColors: [
    '#cbd0ff',
    '#ed5c5c',
    '#ffa800',
    '#a48adb',
    '#8cffc1',
    '#9e56b0',
    '#8cacff',
    '#ffdf8c',
    '#3aa98c',
    '#c6e780'
  ],
  chartDoughnutColors: [
    '#ed5c5c',
    '#ffa800',
    '#8cacff',
    '#8cffc1',
    '#9e56b0',
    '#ffdf8c',
    '#3aa98c',
    '#cbd0ff',
    '#c6e780'
  ],
  chartCircleColors: ['#ffa800', '#8cffc1'],
  bar: {
    tickFontSize: 18,
    colors: [
      '#656af6',
      '#F15A4D',
      '#13AA42',
      '#9E56B0',
      '#17BBAF',
      '#8348ED',
      '#ECCB2B',
      '#38AFF2',
      '#FF9F69'
    ]
  }
}

export default () => ({
  get(name) {
    switch (name) {
    case 'talent_light':
      return talentLight
    case 'talent_dark':
      return talentDark
    }
  }
})
